export default __webpack_public_path__ + "medias/PressKit_FindingSally_june2020-0784228b.pdf";